import { render, staticRenderFns } from "./TemplateCovers.vue?vue&type=template&id=6c2345e8&scoped=true"
import script from "./TemplateCovers.vue?vue&type=script&lang=js"
export * from "./TemplateCovers.vue?vue&type=script&lang=js"
import style0 from "./TemplateCovers.vue?vue&type=style&index=0&id=6c2345e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2345e8",
  null
  
)

export default component.exports